document.addEventListener("DOMContentLoaded", (event) => {

    const button = document.getElementById('load-doc-search');

    if(button){
        let maxDocs = button.dataset.max;
        const term = button.dataset.term;
        const parent = button.parentElement;
        

        if(maxDocs){
            maxDocs = parseInt(maxDocs, 10) -1;
        }else{
            maxDocs = "";
        }

        var $ = require('jquery');

        button.addEventListener('click', ()=>{
            
            if( maxDocs > button.dataset.docint){
                button.dataset.docint = parseInt(button.dataset.docint, 10) + 15;
                let num = button.dataset.docint;
                
                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'html',
                    data: {
                        num: num,
                        except: maxDocs,
                        term: term,
                        action: 'load_search_docs',
                    },
                    success: function (res) {
                        $('#doc-results').html(res);
                    }
                }) 

                if(maxDocs < parseInt(button.dataset.docint, 10)){
                    parent.removeChild(button);
                }
                
            }
            
        });
    }
    
});